import { render } from "./PokemonType.vue?vue&type=template&id=0eb8f064&scoped=true"
import script from "./PokemonType.vue?vue&type=script&lang=js"
export * from "./PokemonType.vue?vue&type=script&lang=js"

import "./PokemonType.vue?vue&type=style&index=0&id=0eb8f064&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noahe\\OneDrive\\Documentos\\Udemy - Vue\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb8f064"]])

export default __exports__